
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
import Computer, { IComputerProps } from "../../components/objects/computer/Computer"
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import { Bootstrapper } from "Bootstrapper"
import { UseBusyIndicatorStore, Update as BusyUpdate } from 'stores/BusyIndicatorStore';
import { UnauthorizedError } from "errors/ApplicationErrors"
import { useNavigate } from "react-router-dom"
import { DialogUtil } from "utils/DialogUtil"
import { Link as NavLink } from 'react-router-dom';
import MyListItem from "components/list/MyListItem"
import Link from "components/buttons/Link"
import DownloadsButton from "views/downloads/DownloadsButton"


class Feature{
    constructor(name: string, comAddin: string, officeAddin: string, isLink: boolean = false){
        this.name = name;
        this.comAddin = comAddin;
        this.officeAddin = officeAddin;
        this.isLink = isLink;
        
    }
    name: string
    comAddin: string
    officeAddin: string
    isLink: boolean;
}

const Addins = (props: any) => {
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return(
        <Box flex="1 1 0" display="flex" flexDirection="column">
            <SectionAddins {...props} />
            <SectionPrivacy isMobile={isMobile} {...props} />
        </Box>
    )
}

const SectionAddins = (props: any) => {
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);
    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }
    const f1 = new Feature("Operating System", ['Windows Only'].join(', '), ['Mac', 'Windows'].join(', '));
    const f2 = new Feature("Word Platform", ['Desktop'].join(', '), ['Desktop', 'Web'].join(', '));
    const f3 = new Feature("File Source", 'Local File System', 'Microsoft OneDrive', );
    const f4 = new Feature("Price", 'Plans', 'Plans', true);

    const users = [
        f1, f2, f3, f4
    ]
    return(
        <Section sx={{flexGrow: 1}} bgColor={bg2}>
            <Container maxWidth="md">
                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                        <TitleBlock sx={{justifyContent: 'start'}}>
                            <Box>
                                <Icon bgCircle>category</Icon>
                                <Heading mt={2} gutterBottom={true} textAlign='left'>Add-ins</Heading>
                            </Box>
                            <SubHeading>Zibbit is available on Windows and Mac</SubHeading>
                                        <Box display='flex' mt={3}>

                                            <Stack spacing={1}>
                                                <MyListItem title="Desktop Add-in" />
                                                <MyListItem title="Office Add-in" />
                                            </Stack>


                                        </Box>
                        </TitleBlock>
                    </div>
                </Animation>

                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='zoom' direction='left' transitionDelay={0}>
                    <div>
                    <Paper >
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"><Text bold>Desktop Add-in</Text></TableCell>
                                <TableCell align="left"><Text bold>Office Add-in</Text></TableCell>
                                {/* <TableCell align="right">Date Registered</TableCell>
                                <TableCell align="right">Action</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map(user => {
                                return (
                                    <TableRow
                                        key={user.name}
                                    >
                                    <TableCell data-label='Feature' align="left" component="th" scope="row">{user.name}</TableCell>
                                    <TableCell 
                                        data-label='Desktop Add-in' 
                                        align="left" 
                                        component="th" 
                                        scope="row">
                                            {user.isLink && <Link to="/plans">{user.comAddin}</Link>}
                                            {!user.isLink && user.comAddin}

                                    </TableCell>
                                    <TableCell 
                                        data-label='Office Add-in' 
                                        align="left" 
                                        component="th" 
                                        scope="row">
                                            {user.isLink && <Link to="/plans">{user.officeAddin}</Link>}
                                            {!user.isLink && user.officeAddin}
                                    </TableCell>
                                </TableRow>
                                )
                            })}

                        </TableBody>
                    </Table>
                    </Paper>
                    </div>
                </Animation>
            </Container>
        </Section>
    )

}


const SectionPrivacy = (props: any) => {
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);
    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }

    return(
        <Section sx={{flexGrow: 1}} bgColor={bg1}>
            <Container maxWidth="md">
                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                        <TitleBlock sx={{justifyContent: isMobile ? 'start' : 'center', textAlign: isMobile ? 'left' : 'center'}}>
                            <Icon bgCircle>verified_user</Icon>
                            <Heading mt={2} gutterBottom={true} textAlign={isMobile ? 'left' : 'center'}>Data Privacy</Heading>
                            <SubHeading textAlign="center">Data privacy is our top priority</SubHeading>
                        </TitleBlock>
                    </div>
                </Animation>

                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='zoom' direction='left' transitionDelay={0}>
                    <div>

                        <Grid
                            container
                            alignItems="stretch"
                            spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Item sx={{height: '100%'}}>
                                    <Paper sx={{height: '100%'}}>
                                        <Box padding={2}>
                                            <Box mb={3}>
                                            <SubHeading>Desktop Add-in</SubHeading>
                                            <Text variant="caption">Windows Only</Text>
                                            <Box display="inline-block" mt={1}>
                                                <DownloadsButton hideChips hideProductOptions hideLogo isDesktopDownloadOverride={true} />
                                                {/* <Button component={NavLink} to="/downloads">Download</Button> */}
                                            </Box>

                                            </Box>
                                            <Stack spacing={3}>
                                                <Box>
                                                <MyListItem alignItems="center"><Text bold>File Source</Text></MyListItem>
                                                <Text>This Add-in runs on your desktop, which allows Zibbit to access your materials from your local file system.</Text>
                                                </Box>
                                            
                                                <Box>
                                                <MyListItem alignItems="center"><Text bold>Data Privacy</Text></MyListItem>
                                                <Text>Your materials are never transmitted, processed, or stored on any remote server. The entire process of assembling your materials into a digital binder is done on your device.</Text>
                                                </Box>

                                                <Box>
                                                    <MyListItem alignItems="center"><Text bold>Data Retention</Text></MyListItem>
                                                    <Text>Not applicable as sensitive data never leaves your device.</Text>
                                                </Box>
                                            </Stack>
                                        </Box>
                                    </Paper>
                                </Item>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Item sx={{height: '100%'}}>
                                <Paper sx={{height: '100%'}}>
                                        <Box padding={2}>
                                            <Box mb={3}>
                                            <SubHeading>Office Add-in</SubHeading>
                                            <Text variant="caption">Mac, Windows</Text>
                                            <Box mt={1} display="inline-block">
                                                <DownloadsButton hideChips hideProductOptions hideLogo isDesktopDownloadOverride={false} />
                                                {/* <Button component={NavLink} to="/downloads?office-addin=true">Download</Button> */}
                                            </Box>
                                            </Box>

                                            <Stack spacing={3}>
                                                <Box>
                                                <MyListItem alignItems="center"><Text bold>File Source</Text></MyListItem>
                                                <Text>This Add-in requires permission to access your materials from Microsoft OneDrive.</Text>
                                                </Box>
                                            
                                                <Box>
                                                <MyListItem alignItems="center"><Text bold>Data Privacy</Text></MyListItem>
                                                <Text>The process for assembling a digital binder occurs on our server. For security, your materials are encrypted in transit and at rest.</Text>
                                                </Box>

                                                <Box>
                                                    <MyListItem alignItems="center"><Text bold>Data Retention</Text></MyListItem>
                                                    <Text>All materials used in preparing your digital binder are deleted from our system within 24 hours.</Text>
                                                </Box>


                                            </Stack>
                                        </Box>
                                    </Paper>
                                </Item>
                            </Grid>

                        </Grid>
                    </div>
                </Animation>
            </Container>
        </Section>
    )

}



export default Addins